import { Sparkles } from "lucide-react";
import { useI18n } from "../lib/i18n";

/** Small quick-pick pills for customer notes on a service.
 *  Clicking a pill fills the target textarea with that text.
 *  Kept intentionally short — 4 curated options cover >80% of typical wishes.
 */
export const NOTE_TEMPLATES_DE = [
  "Wie letztes Mal",
  "Nur oberflächlich",
  "Nicht nötig",
  "Bitte extra sorgfältig",
];
export const NOTE_TEMPLATES_EN = [
  "Same as last time",
  "Surface only",
  "Not needed",
  "Extra care please",
];

const slug = (s) => s.toLowerCase().replace(/[^\w]+/g, "-").replace(/^-|-$/g, "");

export default function NoteTemplatesRow({ onPick, testPrefix, className = "" }) {
  const { lang } = useI18n();
  const de = lang !== "en";
  const templates = de ? NOTE_TEMPLATES_DE : NOTE_TEMPLATES_EN;
  return (
    <div
      className={`flex flex-wrap items-center gap-1.5 mb-1.5 ${className}`}
      data-testid={`note-templates-${testPrefix}`}
    >
      <Sparkles className="w-3 h-3 text-navy-dark/40" strokeWidth={1.6} />
      <span className="text-[10.5px] tracking-widest uppercase text-navy-dark/50 mr-1">
        {de ? "Schnellauswahl" : "Quick pick"}
      </span>
      {templates.map((t, i) => (
        <button
          key={t}
          type="button"
          onClick={() => onPick(t)}
          data-testid={`note-template-${testPrefix}-${slug(de ? t : NOTE_TEMPLATES_DE[i])}`}
          className="text-[11px] tracking-wide px-2 py-0.5 border border-navy/20 text-navy-dark/80 bg-white hover:border-gold hover:bg-gold/10 hover:text-navy transition-colors"
        >
          {t}
        </button>
      ))}
    </div>
  );
}
